import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import EnhancedCard from "common/components/EnhancedCard";
import QuickLinksList from "core/QuickLinks/List";
import Resource from "common/components/Resource";
import { connect } from "react-redux";
import { urlResource } from "common/utils";
import { useTranslation } from "react-i18next";

const QuickLinkListing = ({ resource, history }) => {
  const { t } = useTranslation();
  return (
    <EnhancedCard
      title={t("quick_links_list.title")}
      style={{ position: "relative" }}
      cardContentRoot={{ padding: 0 }}
      cardHeaderStyle={{ fontSize: "1.25rem" }}
    >
      <Resource
        name={`${resource.plural}/${resource.id}/quick_links`}
        queryParams={{}}
        error={() => <Typography>{t("quick_links_list.error")}</Typography>}
        render={(data, { removeOne }) => (
          <QuickLinksList
            quickLinks={(data && data.links) || []}
            data={data}
            removeOne={removeOne}
          />
        )}
      />
    </EnhancedCard>
  );
};

QuickLinkListing.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state, { match }) => ({
  resource: urlResource(match.path),
});

export default connect(mapStateToProps)(QuickLinkListing);
